import { render, staticRenderFns } from "./BankCreditsProfile.vue?vue&type=template&id=31c74f1c"
import script from "./BankCreditsProfile.vue?vue&type=script&lang=js"
export * from "./BankCreditsProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports